import { Component } from '@angular/core';
import { ControlContainer, FormControl, FormGroup, FormGroupDirective, ReactiveFormsModule, Validators } from '@angular/forms';
import { CheckboxFormFieldComponent } from '../fields/checkbox-form-field/checkbox-form-field.component';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { DatepickerFormFieldComponent } from '../fields/datepicker-form-field/datepicker-form-field.component';
import { InputFormFieldComponent } from '../fields/input-form-field/input-form-field.component';
import { TextareaFormFieldComponent } from '../fields/textarea-form-field/textarea-form-field.component';
import { IUser } from 'app/shared/models/users.model';
import { UsersService } from 'app/shared/services/users.service';
import { SelectFormFieldComponent } from '../fields/select-form-field/select-form-field.component';
import { ConfigurationSelectFormFieldComponent } from '../fields/configuration-select-form-field/configuration-select-form-field.component';
import { DropdownEntryEnum, DropdownTypeEnum } from 'app/shared/enums/dropdowns.enum';
import { Subject, takeUntil } from 'rxjs';
import { SelectFormEnum } from 'app/shared/enums/select-form.enum';

@Component({
  selector: 'app-escalation-form',
  standalone: true,
  imports: [CommonModule, TranslateModule, ReactiveFormsModule, CheckboxFormFieldComponent, DatepickerFormFieldComponent, InputFormFieldComponent, ConfigurationSelectFormFieldComponent, SelectFormFieldComponent, TextareaFormFieldComponent],
  templateUrl: './escalation-form.component.html',
  styleUrl: './escalation-form.component.scss',
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
})
export class EscalationFormComponent {

  form: FormGroup | any;
  viewMode: boolean = true;
  dropdownType: string = DropdownTypeEnum.ESCALATION_CATEGORY;
  dropdownTypeEnum = DropdownTypeEnum;
  entry1 = DropdownEntryEnum.ENTRY_1;
  customerEscalated!: boolean;
  customerInternalUsers: IUser[] = [];
  escalationTeamUsers: IUser[] = [];
  private destroy$ = new Subject<void>();

  constructor(
    public mainForm: FormGroupDirective,
    private usersService: UsersService
  ) { }

  ngOnInit(): void {
    this.createForm();
    this.getUsersData();
  }

  createForm() {
    this.form = this.mainForm.form;

    this.form.addControl(
      'caseEscalation',
      new FormGroup({
        customerEscalated: new FormControl(false, []),
        customerEscalatedDate: new FormControl({ value: null, disabled: true }),
        escalationCategory: new FormControl(null, []),
        customerEscalatedByWhomInternal: new FormControl(null, []),
        customerEscalatedByWhomExternal: new FormControl(null, []),
        escalationTeam: new FormControl(null, []),
        reasonForEscalation: new FormControl(null, []),
        escalatedDate: new FormControl({ value: null, disabled: true }),
        deEscalatedDate: new FormControl({ value: null, disabled: true }),
      })
    );
  }

  onCheckEscalateCustomer(value: boolean) {
    this.customerEscalated = value;
    const escalationCategory: FormControl = this.form.get('caseEscalation').get('escalationCategory') as FormControl;
    const escalationTeam: FormControl = this.form.get('caseEscalation').get('escalationTeam') as FormControl;
    const reasonForEscalation: FormControl = this.form.get('caseEscalation').get('reasonForEscalation') as FormControl;
    const customerEscalatedDate: FormControl = this.form.get('caseEscalation').get('customerEscalatedDate') as FormControl;

    if (value) {
      customerEscalatedDate?.patchValue(new Date());
      escalationCategory?.setValidators([Validators.required]);
      escalationTeam?.setValidators([Validators.required]);
      reasonForEscalation?.setValidators([Validators.required]);
    } else {
      customerEscalatedDate?.reset();
      escalationCategory?.clearValidators();
      escalationTeam?.clearValidators();
      reasonForEscalation?.clearValidators();
    }

    escalationCategory.updateValueAndValidity();
    escalationTeam.updateValueAndValidity();
    reasonForEscalation.updateValueAndValidity();
  }

  getUsersData() {
    this.usersService.users$.subscribe((users: IUser[]) => {
      this.escalationTeamUsers = users;
      this.customerInternalUsers = users;
    });
  }

  searchUsers(event: string, term: string, usersList: string, page: number = 0, take: number): void {
    this.usersService.getUsers(term, page * take, take)
      .pipe(takeUntil(this.destroy$))
      .subscribe((users: IUser[]) => {
        if (event === SelectFormEnum.SCROLL) {
          (this as any)[usersList] = [...(this as any)[usersList], ...users];
        } else if (event === SelectFormEnum.SEARCH) {
          (this as any)[usersList] = [...users];
        }
      });
  }

}
